<template>
    <div>
            {{addisonDownloadLink}}
            <!-- test -->
            <p> <a :href="addisonDownloadLink" 
            class="rounded-lg bg-gray-200 px-4 py-1" download>
                <!-- <Icon name="download"></Icon> --> test
            </a></p>
         <!-- <p> Download from here </p> -->
       <!-- <p> <a class=" px-4 py-4 bg-gray-800 border rounded-md text-white " 
             :href="addison-download" >
            DOWNLOAD HERE  
        </a></p> -->
     </div>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue3';
export default {
    components:{
        Head,
    
    },
    props:{
        'addisonDownloadLink': String 
    }
}
</script>